<template>
  <a-modal
    :title="$t('content.form_title')"
    width="70%"
    :open="visible"
    :footer="null"
    @cancel="closeModal"
    ref="modal"
  >
    <dynamic-content-form
      :userDb="userDb"
      @saved="addContent"
      :fromModal="true"
    />
  </a-modal>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex';
import DynamicContentForm from '../dynamic-contents/DynamicContentForm.vue';

export default {
  name: 'DynamicContentsModal',
  components: {
    DynamicContentForm
  },
  data() {
    return {
      visible: false,
      userDb: undefined
    };
  },
  computed: mapState({
    dynamicContentsOpen: state => state.dynamicContentsOpen,
    dynamicContentsSaved: state => state.dynamicContentsSaved,
    templateData: state => state.templateData,
    newsletterUserDb: state => state.userDb
  }),
  methods: {
    ...mapActions(['rejectDynamicContent', 'resolveDynamicContent']),
    ...mapMutations(['setDynamicContentsOpen', 'setDynamicContentsSaved']),

    closeModal() {
      this.visible = false;
      this.setDynamicContentsOpen(false);
      if (!this.dynamicContentsSaved) {
        this.rejectDynamicContent();
      }
    },

    showModal() {
      this.visible = true;
    },

    addContent(payload) {
      this.resolveDynamicContent(payload).then(() => {
        this.setDynamicContentsSaved(true);
        this.closeModal();
      });
    }
  },
  watch: {
    dynamicContentsOpen(newValue) {
      if (newValue) {
        const {mergeTagsSource} = this.templateData || {};
        if (mergeTagsSource?.extended?.userDbId) {
          this.userDb = mergeTagsSource.extended.userDbId;
        } else if (this.newsletterUserDb != null) {
          this.userDb = parseInt(this.newsletterUserDb);
        }
        this.setDynamicContentsSaved(false);
        this.showModal();
      }
    }
  }
};
</script>

<style scoped>
#modal-title {
  text-align: left;
}
</style>
